module.exports = __webpack_public_path__ + "static/template-create-f2ce7e2cf996c2e46b50fb3a4be75ab3.png";